@if (isDragging()) {
  <div class="drag-overlay">
    <div class="drag-icon">
      <ui-icon faName="upload" faStyle="light"></ui-icon>
    </div>
    <p class="drag-text">{{ multiple() ? 'Dateien' : 'Datei' }} hierher ziehen</p>
  </div>
}

<div class="drag-zone-content">
  <ng-content></ng-content>
</div>
